module.exports = __webpack_public_path__ + "img/蒙版组 4.f7ed53b8.png";